import { render, staticRenderFns } from "./ControlSliders.vue?vue&type=template&id=7371227e&"
import script from "./ControlSliders.vue?vue&type=script&lang=js&"
export * from "./ControlSliders.vue?vue&type=script&lang=js&"
import style0 from "./ControlSliders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports